<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeCommentaire.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsCommentaire.maj) }"
               @click="checkPermissions(permsCommentaire.maj) ?
                openPopUpAjoutEditCommentaire = true : showPopUp()">
              {{ $t('listeCommentaire.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="$refs.tableCommentaire.refresh()" class="column is-12">
            <b-input :placeholder="$t('listeCommentaire.actions.search')"
                     type="search" icon="magnify" v-model="filterInput">
            </b-input>
          </form>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsCommentaire.exporter"
            in-progress/>
        </div>
      </div>
    </div>
    <v-server-table :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    ref="tableCommentaire"
                    :data="listeCommentaireFilter">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableCommentaire.setLimit($event)"/>
      </template>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permsCommentaire.maj) ?
          editCommentaire(props.row.id) : showPopUp()">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsCommentaire.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsCommentaire.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsCommentaire.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsCommentaire.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsCommentaire.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="openPopUpAjoutEditCommentaire"
              has-modal-card @close="makeSearchAfterAddEdit()"
             class="modal">
      <pop-up-add-edit-commmentaire
        @reloadCommentaire="$refs.tableCommentaire.refresh()"
        :commentaireId="commentaireId">
      </pop-up-add-edit-commmentaire>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import inProgress from '@/services/general/inProgress';
import { COMMENTAIRE } from '@/configuration/general/permissionsParametrageConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import popUpAddEditCommmentaire from '@/components/parametrage/commentaire/p_addEditCommentaire';
import TableItemsInView from '@/components/general/TableItemsInView';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const permissions = createNamespacedHelpers('permissions');
const Commentaire = createNamespacedHelpers('commentaire');

export default {
  data() {
    return {
      permsCommentaire: COMMENTAIRE,
      commentaireId: null,
      openPopUpAjoutEditCommentaire: false,
      filter: '',
      filterInput: '',
      loadingComponent: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    popUpAddEditCommmentaire,
    TableItemsInView,
    exportExcelButton,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Commentaire.mapGetters({
      listeCommentaire: 'items',
      totalCount: 'totalCount',
    }),
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeCommentaire.title'), route: { name: '' }, isActive: true },
      ];
    },
    listeCommentaireFilter() {
      return this.listeCommentaire.filter(commentaire => {
        return commentaire.libelle.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase())
        || commentaire.message.toLocaleLowerCase().includes(this.filter.toLocaleLowerCase());
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          message: this.$t('listeCommentaire.tab.libelle'),
          libelle: this.$t('listeCommentaire.tab.commentaire'),
          edit: '',
          delete: '',
          archive: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archive: 'colonneSelected',
        },
        sortable: ['libelle', 'message'],
        requestFunction: ((data) => {
          data.query = {
            auto: this.filterInput,
          };
          return this.actionsLoadCommentaire(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.listeCommentaire,
            count: this.totalCount,
          };
        }),
      };
    },
    columns() {
      return ['libelle', 'message', 'edit', 'archive', 'delete'];
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Commentaire.mapActions({
      actionsLoadCommentaire: 'loadCommentaire',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    editCommentaire(commentaireId) {
      this.commentaireId = commentaireId;
      this.openPopUpAjoutEditCommentaire = true;
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    makeSearchAfterAddEdit() {
      this.commentaireId = null;
      this.$refs.tableCommentaire.refresh();
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageParametrage.commentaires.liste'));
  },
};

</script>
